import React from "react";
import InteractiveMapPage from "../interactiveMapPage";
import mountBaturImage from "../../3-assets/images/bali/mountbatur/sunrise-right.jpg";
import mountBaturGroupImage from "../../3-assets/images/bali/mountbatur/group.jpg";
import mountBaturBenjiImage from "../../3-assets/images/bali/mountbatur/me.jpg";
import lekeLekeImage from "../../3-assets/images/bali/leke-leke/waterfall-horizontal.jpg";
import mundukImage from "../../3-assets/images/bali/munduk/munduk-hotel.jpg";
import ubudImage from "../../3-assets/images/bali/ubud/ubud-monkeys.jpg";
import ubudBenjiImage from "../../3-assets/images/bali/ubud/me.jpg";
import lovinaImage from "../../3-assets/images/bali/lovina/lovina-beach.jpg";
import banyumalaImage from "../../3-assets/images/bali/banyumala/waterfall-horizontal.jpg";
import banjarImage from "../../3-assets/images/bali/banjar-springs/pool.jpg";
import ulunDanuImage from "../../3-assets/images/bali/ulun-danu-baratan/temple.jpg";
import gitGitImage from "../../3-assets/images/bali/git-git/waterfall.jpg";
import mundukRiceTerraceImage from "../../3-assets/images/bali/munduk-rice-terraces/flower.jpg";
import patImage from "../../3-assets/images/bali/ubud/pat.jpg";

const events = [
  {
    images: [],
    paragraphs: [
      "After my Grandpa’s funeral and a few days of shiva, I flew from Chicago to Bali. I arrived around 1am, and a few hours later its largest volcano, Mount Agung, erupted. The neighboring towns had to evacuate thousands of people, but I didn’t even realize until my friends I left in Vietnam texted me the next day if I was alright. ",
      "When I arrived, I went to the nearby main town of Kuta. I’m not a fan of Kuta. It is very much a party town, but in the worst way. It was really hard to find Indonesian food at all, and way too easy to find burger joints and Italian restaurants. The beach was nice, but Kuta is extraordinarily skippable. I left the next day to Ubud."
    ],
    location: {
      name: "Kuta",
      coordinates: {
        lat: -8.719266,
        lng: 115.1767
      }
    }
  },
  {
    images: [ubudImage, ubudBenjiImage],
    paragraphs: [
      "Ubud is touted as the cultural capital of Kuta. It was much more my vibe. It had a balance of nature trails, rice fields, and waterfalls around the city while housing an eccentric collection of restaurants and coffee shops that still maintain its Balinese character. A lot of people come to Ubud and stay for weeks.",
      "My first day, I explored the Sacred Monkey Forest, a huge forest with thousands of monkeys. One monkey the size of my forearm had a messed up eye was dead set on taking my camera. His eye made it easy to know it was the same monkey that tried to open my backpack or take my camera a half dozen times. At first I felt bad for him, but now I know how he likely got his eye messed up. ",
      "I took a 90 minute yoga class at the  Yoga Barn, a huge complex of yoga studios on the edge of the jungle. It was an easy way to make some friends.",
      "One night, I was talking to a girl I’d just met, Cas, when I met Pat —  the most interesting man in the world."
    ],
    location: {
      name: "Ubud",
      coordinates: {
        lat: -8.5069,
        lng: 115.2625
      }
    }
  },
  {
    images: [patImage],
    paragraphs: [
      "Pat was a loud and chunky Australian guy in his late 20s that looked more Irish than Australian. He had a bandaged foot from some mysterious ‘accident,’ and I caught him a few times with his boxers poking out of his zipper. He jutted into our conversation, and it was pretty clear that he might have been somewhere on the spectrum given the awkward way he communicated. ",
      "Pat has been traveling through Bali for almost two years, without a phone, computer, or any form of communication. When I told him I was planning on leaving Ubud the next day, he took my phone and said he was going to help me. I was little nervous just handing him my phone, but over the next two hours (occasionally asking permission to check the score of some soccer game), he planned every step of my itinerary for the next week.",
      "He was in the zone and there was no chance I would get my phone back during that two hours, but he was like having a spontaneous master travel agent. He even invited Cas, who I’d known for a total of 30 minutes and hadn’t quite gotten her name down, to join me, which she said yes.",
      "The next morning, Pat and I left on his motorcycle to find a car driver to take us on the beginning of the journey. I thought I could barter well, but Pat was a different animal. Over the next hour, we bartered with 8 different drivers. He was fierce, and as it turns out, fluent in the local language. When I tried to jut in, he would tell me to go wait somewhere while he handled it, jumping between Balinese and English, yelling at times.",
      "In the end, Pat negotiated a guy to drive us to our next city, stop at a bunch of places on the way, stay overnight, and do the same thing the next day to another destination for less than the half the price some of the drivers quoted just to go to our first city.",
      "By the time we and the driver picked up Cas, Cas’s friend Jose (who I’d never met before) decided to join the week-long trip too. Pat didn’t come with us, but before we left him, he asked if he could call his dad on my phone. Later his dad messaged me to contact him if we ever needed something, and he’d try to tell Pat the next time Pat found a way to call him.",
      "I had told Pat he could open up his own travel agency. He said he’d thought about it, but likes planning more organic things like this for fun. Pat is the man, and I decided to make this website on that car ride so I wouldn’t forget crazy experiences like this."
    ],
    location: {
      name: "Pat",
      coordinates: {
        lat: -8.5069,
        lng: 115.2625
      }
    }
  },
  {
    images: [mountBaturImage, mountBaturGroupImage, mountBaturBenjiImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Mount Batur",
      coordinates: {
        lat: -8.2401,
        lng: 115.3775
      }
    }
  },
  {
    images: [lekeLekeImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Leke Leke",
      coordinates: {
        lat: -8.364163,
        lng: 115.197301
      }
    }
  },
  {
    images: [ulunDanuImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Ulun Danu Baratan",
      coordinates: {
        lat: -8.2752,
        lng: 115.1668
      }
    }
  },
  {
    images: [gitGitImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Git Git",
      coordinates: {
        lat: -8.1877,
        lng: 115.1366
      }
    }
  },
  {
    images: [lovinaImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Lovina",
      coordinates: {
        lat: -8.1611,
        lng: 115.0244
      }
    }
  },
  {
    images: [banjarImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Banjar springs",
      coordinates: {
        lat: -8.210249,
        lng: 114.96699
      }
    }
  },
  {
    images: [banyumalaImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Banyumala",
      coordinates: {
        lat: -8.217,
        lng: 115.102
      }
    }
  },
  {
    images: [mundukImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Munduk",
      coordinates: {
        lat: -8.2666,
        lng: 115.0547
      }
    }
  },
  {
    images: [mundukRiceTerraceImage],
    paragraphs: ["placeholder"],
    location: {
      name: "Munduk Rice Terraces",
      coordinates: {
        lat: -8.2666,
        lng: 115.0547
      }
    }
  }
];

export default function Bali() {
  return <InteractiveMapPage events={events} countryName="Bali" />;
}
